import { IconTargetArrow } from "@tabler/icons";
import keywordresearchforppc from "../json/keywordresearchforppc";
import adcopiesgeneration from "../json/adcopiesgeneration";

// constant
const icons = {
  IconTargetArrow,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const ppccampaign = {
  id: "ppccampaign",
  title: "PPC Campaign",
  caption: "PPC Campaign",
  type: "group",
  children: [
    {
      id: "ppccampaign",
      title: "PPC Campaign",
      type: "collapse",
      icon: icons.IconTargetArrow,

      children: [
        {
          id: "research-for-PPC",
          title: "Keyword research for PPC",
          titleType: "collapse",
          type: "item",
          url: "/research-for-PPC",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/ppckeywordresearch",
          jsonobject: keywordresearchforppc,
          editorTitile: "A list of relevant keywords for your PPC campaign",
          mainTitile: "Keyword research for PPC",
          mainDescription:
            "This feature enables you to input a topic or keyword, and the app will generate a list of relevant keywords for your PPC campaign.",
        },
        {
          id: "copies-generation",
          title: "Ad copies generation",
          titleType: "collapse",
          type: "item",
          url: "/copies-generation",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/adcopies",
          jsonobject: adcopiesgeneration,
          editorTitile: "Ad copies for your PPC campaign",
          mainTitile: "Ad copies generation",
          mainDescription:
            "This feature enables you to input a topic or keyword, and the app will generate ad copies for your PPC campaign.",
        },
      ],
    },
  ],
};

export default ppccampaign;
